import type { ApiClient } from "./shared/api-client";
import { useRouteContext } from "./shared/route-context";

export function useApiClient(): ApiClient {
	const { apiClient } = useRouteContext();
	return apiClient;
}
